import styled from "styled-components"
import { Avatar } from "primereact/avatar"

const StyledAvatar = styled(Avatar)``
export default StyledAvatar
